<template>
  <span class="material-symbols-rounded p-0" :class="iconClasses">
    {{ icon }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  color: {
    type: String,
    required: false,
  },

  icon: {
    type: String,
    required: true,
  },

  size: {
    type: String,
    default: "24",
    required: false,
  },
});

const iconClasses = computed(() => {
  const classes = [];

  if (props.color) {
    classes.push(`text-${props.color}`);
  }
  if (props.size) {
    classes.push(`fs-${props.size}`);
  }

  return classes.join(" ");
});
</script>

<style lang="scss" scoped>
@import "@/designSystem/style/main.scss";

.fs-12 {
  font-size: 0.923rem;
}

.fs-16 {
  font-size: 1.231rem;
}

.fs-24 {
  font-size: 1.846rem;
}

.fs-32 {
  font-size: 2.462rem;
}

.fs-48 {
  font-size: 3.692rem;
}

.fs-64 {
  font-size: 4.923rem;
}
</style>
